const ACCOUNT_HEADER = 'Stripe-Account';
const LIVEMODE_HEADER = 'Stripe-Livemode';
const CONTEXT_HEADER = 'Stripe-Context';
export default function addContextHeaders(headers, v2Context, routeThroughEdge) {
    const { id } = v2Context;
    const compartmentIdValue = id || null;
    // Force stripe-account in cases where stripe-context was set by something else
    if (compartmentIdValue !== null && !headers.get(CONTEXT_HEADER)) {
        headers.set(CONTEXT_HEADER, compartmentIdValue);
    }
    // This is done here to cover the case where someone has already set the header
    const finalValue = headers.get(CONTEXT_HEADER);
    if (finalValue && routeThroughEdge) {
        // This has to be here until we remove graphql gateway tunneling through manage
        // on devbox.  This further forks prod behavior but it's unavoidable.  Check back
        // with @alusco on this by end Q1, we are hoping to remove the need for this.
        // See #ir-akin-stack as a reason this has to be here.
        headers.set(ACCOUNT_HEADER, finalValue);
    }
    // Force the livemode for all "user" queries,
    // because Edge relies on it to set the request priority tier
    if (!finalValue) {
        headers.set(LIVEMODE_HEADER, String(true));
    }
}

//# sourceMappingURL=addContextHeaders.js.map